import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import FallaDesembarque from './FallaDesembarque.js';
import ACCESS from '../../../ACCESS.js';

class FallasDesembarques extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'falla-desembarque/filter', deleteUrl: 'falla-desembarque/delete', deleteField: 'falla_desmb_nombre', modUrl: '/Catalogo/FallaDesembarque' },
      TableOp.Table('Falas de Desembarque', [
        { label: 'Clave', id: 'falla_desmb_falla' },
        { label: 'Nombre', id: 'falla_desmb_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_FALLAS_DE_DESEMBARQUE.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_FALLAS_DE_DESEMBARQUE.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <FallaDesembarque  onSave={() => {this.table()}}></FallaDesembarque>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(FallasDesembarques)